
import { Component, Mixins, Prop } from "vue-property-decorator";
import { VuetifyMixin, MindsetMixin, MindsetReportMixin, HelpInfoMixin, BAIconsMixin } from "@/mixins";

import RyzerAthleteTypeCard from '@/components/mindset/RyzerAthleteTypeCard.vue';
import RyzerScore from "@/components/ui/RyzerScore.vue";
import MindsetInformation from '@/components/mindset/MindsetInformation.vue'
import SubscriptionInfoProvider from "@/components/hoc/SubscriptionInfoProvider.vue";
import { RyzerNone } from "@/../types/constants/ryzer";
import { AthleteProfileModel } from '@/models';

@Component({
	components: {
		RyzerScore,
		RyzerAthleteTypeCard,
		MindsetInformation,
		SubscriptionInfoProvider
	}
})
export default class AthleteMindsetReportCard extends Mixins(VuetifyMixin, MindsetMixin, MindsetReportMixin, HelpInfoMixin, BAIconsMixin) {
	@Prop({ required: true }) athleteProfile: AthleteProfileModel;
	@Prop({ type: Boolean }) buttons;
	@Prop({ type: Boolean }) extended;
	@Prop({ type: Boolean }) flat;
	@Prop({ type: Boolean }) hideIfNoShare;

	get MindsetAssessmentEligible(): boolean {
		return !this.HasMindsetReport && this.AthleteAppActive;
	}
	get MindsetColor(): Record<string, any> {
		if( this.publicView ) return { color: RyzerNone.color };

		return this.MindsetArchetypeTextColor;
	}
	get ShareAssessment(): boolean {
		if( !this.hideIfNoShare ) return true;
		return this.athleteProfile?.profileVisibility?.recruiter?.mindsetReport;
	}
}
